import { defineStore } from 'pinia'
import { TOKEN } from '@/constants/storage'
import router from '@/router'
import Storage from '@/utils/storage'
import { broadcastChannel } from '@/utils/window-event'
import websocket from '@/websocket/index.js'

// 是否已监听 mqtt 断开事件
let disconnectListening = false

export const useUserStore = defineStore('user', {
  state: () => ({
    isLogined: false, // 是否已经登录
    userInfo: {}, // 登录返回的用户信息
    mqttStatus: 'disconnected', // mqtt 连接状态, disconnected(未连接)/connecting(连接中)/connected(已连接)
  }),
  getters: {
    userId: (state) => state.userInfo.id,
  },
  actions: {
    // 登录状态
    setIsLogined(payload) {
      this.isLogined = payload
    },
    // 退出
    logout(path) {
      this.isLogined = false
      Storage.remove(TOKEN)
      this.userInfo = {}
      broadcastChannel.postMessage()
      // 重定向
      if (path) {
        router.replace(path)
      }
    },
    // 设置用户信息
    setUserInfo(params) {
      this.userInfo = params || {}
    },
    // 连接 mqtt
    async connectMqtt() {
      if (this.mqttStatus !== 'disconnected') {
        return
      } else if (!disconnectListening) {
        websocket.on('disconnect', () => {
          this.mqttStatus = 'disconnected'
        })
        disconnectListening = true
      }
      this.mqttStatus = 'connecting'
      try {
        await websocket.connect()
        this.mqttStatus = 'connected'
      } catch (e) {
        console.log(e)
        this.mqttStatus = 'disconnected'
        throw e
      }
    },

    // 连接 mqtt
    disconnectMqtt() {
      websocket.disconnect()
      this.mqttStatus = 'disconnected'
      // context.commit('setMqttStatus', 'disconnected')
    },
  },
  persist: {
    storage: localStorage,
    pick: ['isLogined', 'userInfo'],
  },
})
